import { render, staticRenderFns } from "./subcategoryStatus.vue?vue&type=template&id=6368825e&"
import script from "./subcategoryStatus.vue?vue&type=script&lang=js&"
export * from "./subcategoryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports